import * as types from './types';

export const fetchNotificationsRequest = (payload) => ({
  type: types.FETCH_NOTIFICATIONS_REQUEST,
  payload
});

export const fetchNotificationsSuccess = (payload) => ({
  type: types.FETCH_NOTIFICATIONS_SUCCESS,
  payload
});

export const fetchNotificationsFailure = (error) => ({
  type: types.FETCH_NOTIFICATIONS_FAILURE,
  payload: error
});

export const markNotificationReadRequest = (id) => ({
  type: types.MARK_NOTIFICATION_READ_REQUEST,
  payload: id
});

export const markNotificationReadSuccess = (id) => ({
  type: types.MARK_NOTIFICATION_READ_SUCCESS,
  payload: id
});

export const markNotificationReadFailure = (error) => ({
  type: types.MARK_NOTIFICATION_READ_FAILURE,
  payload: error
});

export const setNotificationCount = (count) => ({
  type: types.SET_NOTIFICATION_COUNT,
  payload: count
});

export const openNotificationModal = () => ({
  type: types.OPEN_NOTIFICATION_MODAL
});

export const closeNotificationModal = () => ({
  type: types.CLOSE_NOTIFICATION_MODAL
});
